import React, { FC } from 'react'
import { Radio } from './Radio'
import { Box, RadioGroup, VStack } from '@chakra-ui/react'

export interface IRadioOption {
  value: string | number
  label: string | React.ReactNode
}

export const RadioList: FC<{
  name: string
  onChange: (val: string) => void
  options: IRadioOption[]
  value: string | number | null
}> = ({ name, onChange, options, value }) => {
  return (
    <RadioGroup
      p={'16px 0'}
      value={value ?? undefined}
      aria-labelledby={name}
      onChange={onChange}
    >
      <VStack align="stretch" spacing="12px">
        {options.map((option) => {
          return (
            <Box p="0 16px" key={option.value}>
              <Radio
                variant="withTickbox"
                size="sm"
                value={option.value}
                name={name}
              >
                {option.label}
              </Radio>
            </Box>
          )
        })}
      </VStack>
    </RadioGroup>
  )
}
